
let targetElem, targetElement1, targetElement2, waitForElement, waitForElement2, waitForElement3, breedsizes, atleastOneSelected = false, chosenSize = null;
let matchingSizes, matchingResults, chosenByArrow, downEventListening;
  
breedsizes  = JSON.parse( document.getElementById('NPAjson').innerHTML);
    
let sizeids = { XS: ["37540578002", "yellow"], S: ["37843250002", "red"], M: ["37843200658", "blue"], L: ["37843255122", "green"], XL: ["37844540818", "purple"], XXL: ["37844543826", "orange"], XXXL: ["37844544466", "navy"] };


// for the A/B Test Section
let abAtcButton = document.querySelector('.ab-atc');
let abElement = document.querySelector('#size-finder');


const waitForNewTarget = function () {
        targetElem = document.querySelector('.npa-2022-tab-content1');
  
        targetElement1 = document.querySelector('form#product-form-9876434002');
        targetElement2 = document.querySelector('form#product-form-7724315050213');
  
        waitForElement = document.querySelector('form#product-form-9876434002 .select-size-parent');
    
        if (!targetElem && !targetElement1 && !targetElement2) {
          // wait for the target element to be present on the page
          setTimeout( waitTarget, 500 );
          return;
        }

        // console.log("Loading breed names from assets");
        // Yes or No Tabs Switching Logic
        Array.from(document.querySelectorAll(".npa-2022-tab")).forEach( tab => {
            tab.addEventListener("click", function(){
                if(tab.dataset.youknow == "yes") {
                    // console.log("Tab Yes Clicked");
                    document.querySelector(".npa-2022-tab-content1").classList.remove("npa-2022-block");
                    document.querySelector(".npa-2022-tab-content1").classList.add("npa-2022-hidden");
                    document.querySelector(".npa-2022-tab-content2").classList.remove("npa-2022-hidden");
                    document.querySelector(".npa-2022-tab-content2").classList.add("npa-2022-block");
                    document.querySelectorAll(".npa-2022-tab")[0].classList.remove("active");
                    tab.classList.add("active");
                } else if(tab.dataset.youknow == "no") {
                    // console.log("Tab No Clicked");
                    document.querySelector(".npa-2022-tab-content1").classList.remove("npa-2022-hidden");
                    document.querySelector(".npa-2022-tab-content1").classList.add("npa-2022-block");
                    document.querySelector(".npa-2022-tab-content2").classList.remove("npa-2022-block");
                    document.querySelector(".npa-2022-tab-content2").classList.add("npa-2022-hidden");
                    document.querySelectorAll(".npa-2022-tab")[1].classList.remove("active");
                    tab.classList.add("active");
                }
            }, false);
        });
  
    //Total matching Results when user starts typing breed name
    matchingResults = 0;
    matchingSizes = 0;
    downEventListening = false;

    //When User starts typing in the Text Field, bring the suggestions 
    document.getElementById("npa20221005-textfield").addEventListener("focus", function(){
        bringSuggestionBox();
    }, false);

    //When User presses Esc to close the suggestion
    document.addEventListener("keydown", function(event){
        if(event.key == "Escape") {
            closeSuggestionBox();
        }
    }, false);


    //When the user types a value in the search breed text field
    document.getElementById("npa20221005-textfield").addEventListener("input", function(){

        //if suggestion drop-down blurred by accident
        if(document.getElementById("npa20221005-suggestion").classList.contains("npa20221005-hidden")) {
            bringSuggestionBox();
        }

        //Clear out any previous recommendation
        document.getElementById("npa20221005-weight-leadingText").innerHTML = "";
        document.getElementById("npa20221005-weight-results").innerHTML = "";
        document.getElementById("npa20221005-final-results").innerHTML = "";
        document.getElementById("npa20221005-final-leadingText").innerHTML = "";

        if(this.value.length >= 3) {
          
          document.getElementById("npa20221005-textfield").parentNode.classList.remove("npa20221005-tick");
          //Reset the suggestions and count
          document.getElementById("npa20221005-suggestion").innerHTML = "";
          matchingResults = 0;

          //Loop through all the breed sizes from the array
          breedsizes.forEach(breed => {
              // Find if the value typed is present in any of the looped through data
              var dogname = breed.name.toLowerCase().trim();
              if(dogname.indexOf(this.value.toLowerCase().trim()) !== -1) {
                  // If present add one to the matching results count
                  matchingResults++;

                  //create a div with the suggestion and add it to the suggestion drop down
                  let option = document.createElement("div");
                  option.classList.add("npa20221005-suggestion-option", "npa20221005-p1");
                  option.setAttribute("data-breed", breed.name);
                  option.setAttribute("data-size1", JSON.stringify(breed.size1));
                  option.setAttribute("data-size2", JSON.stringify(breed.size2));
                  option.setAttribute("data-size3", JSON.stringify(breed.size3));
                  option.setAttribute("data-size4", JSON.stringify(breed.size4));
                  option.setAttribute("data-size5", JSON.stringify(breed.size5));
                  option.setAttribute("data-size6", JSON.stringify(breed.size6));
                  option.setAttribute("data-size7", JSON.stringify(breed.size7));
                  option.innerHTML = "<button class='npa20221005-choosable-option'>"+breed.name+"</button>";
                  document.getElementById("npa20221005-suggestion").appendChild(option);
              }
          }); 

          //After a delay of 0.2 seconds after adding all the suggestion
          setTimeout(()=> {

              //Highlight the first one ready to be selected by Enter
              chosenByArrow = 0;
              if(matchingResults>0) {
                highlightOption(chosenByArrow);
              
              
                if(!downEventListening) {
                  window.addEventListener("keydown",  addKeyDownEventForHighlight, false ); 
                  window.addEventListener("keydown", addKeyDownEventForEnter, false );
                  downEventListening = true;
                }

                //Loop through all the suggestions in the drop-down and add click event listener to all the options
                Array.from(document.querySelectorAll(".npa20221005-suggestion-option")).forEach( opt => {
                            
                  opt.addEventListener("click", function(ev){
                    ev.stopImmediatePropagation();
                    matchingSizes = 0;
                    dogBreedChosen(opt, opt.dataset.breed);
                    window.removeEventListener("keydown", addKeyDownEventForHighlight);
                    window.removeEventListener("keydown", addKeyDownEventForEnter);
                    downEventListening = false;
                });

            });

            }

          }, 200);

       }

        // If all the characters are removed from the search box, suggest user to start typing
        if(this.value.length <= 2) {
            document.getElementById("npa20221005-suggestion").innerHTML = "<p> Type at least 3 characters to see suggestions </p>";
            window.removeEventListener("keydown", addKeyDownEventForHighlight);
            window.removeEventListener("keydown", addKeyDownEventForEnter);
          
          // for the A/B Test Section
          if (abAtcButton) {
            abAtcButton.classList.add('disabled');
            abAtcButton.textContent = "SELECT BREED TO BEGIN ⬆️";
          }
          
            downEventListening = false;
        } 
        
       else if(matchingResults == 0) {
            // If there are no matching results
            document.getElementById("npa20221005-suggestion").innerHTML = "<p> No matches Found. Please try a different term </p>";
            window.removeEventListener("keydown", addKeyDownEventForHighlight);
            window.removeEventListener("keydown", addKeyDownEventForEnter);
            downEventListening = false;
        }
    }, false);

}

function dogBreedChosen(suggestionOption, breedName) {

    //when an option is clicked, set the clicked option's value in the text field
    document.getElementById("npa20221005-textfield").value = suggestionOption.dataset.breed;
    document.getElementById("npa20221005-textfield").parentNode.classList.add("npa20221005-tick");

    if(document.getElementById('breedProperties')) {
      var breedValue = document.getElementById("npa20221005-textfield").value;

      document.getElementById('breedProperties').value = breedValue;
    }

    document.getElementById("npa20221005-weight-results").innerHTML = "";
    document.getElementById("npa20221005-weight-leadingText").innerHTML = "Weight range of your " + (suggestionOption.dataset.breed == "I don't know" ? "dog" : suggestionOption.dataset.breed) + " in pounds (lbs):";

    if(suggestionOption.dataset.size1 != "null") {
        matchingSizes++;
        let tempObj = JSON.parse(suggestionOption.dataset.size1);
        if(suggestionOption.dataset.size2 == "null") {
          npaWeightRanges(suggestionOption.dataset.breed, tempObj, true);
        } else {
        npaWeightRanges(suggestionOption.dataset.breed, tempObj);
        }
    }
  
    if(suggestionOption.dataset.size2 != "null") {
        matchingSizes++;
        let tempObj = JSON.parse(suggestionOption.dataset.size2);
        npaWeightRanges(suggestionOption.dataset.breed, tempObj);
    }
    if(suggestionOption.dataset.size3 != "null") {
        matchingSizes++;
        let tempObj = JSON.parse(suggestionOption.dataset.size3);
        npaWeightRanges(suggestionOption.dataset.breed, tempObj);
    }
    if(suggestionOption.dataset.size4 != "null") {
        matchingSizes++;
        let tempObj = JSON.parse(suggestionOption.dataset.size4);
        npaWeightRanges(suggestionOption.dataset.breed, tempObj);
    }
    if(suggestionOption.dataset.size5 != "null") {
        matchingSizes++;
        let tempObj = JSON.parse(suggestionOption.dataset.size5);
        npaWeightRanges(suggestionOption.dataset.breed, tempObj);
    }
    if(suggestionOption.dataset.size6 != "null") {
        matchingSizes++;
        let tempObj = JSON.parse(suggestionOption.dataset.size6);
        npaWeightRanges(suggestionOption.dataset.breed, tempObj);
    }
    if(suggestionOption.dataset.size7 != "null") {
        matchingSizes++;
        let tempObj = JSON.parse(suggestionOption.dataset.size7);
        npaWeightRanges(suggestionOption.dataset.breed, tempObj);
    }
    
    //If more than size is suggested display info about exchange
  
    // if(matchingSizes > 1) {
    //     document.getElementById("npa20221005-exchange-info").classList.remove("npa20221005-hidden");
    //     document.getElementById("npa20221005-exchange-info").classList.add("npa20221005-block");
    // } else {
    //     document.getElementById("npa20221005-exchange-info").classList.remove("npa20221005-block");
    //     document.getElementById("npa20221005-exchange-info").classList.add("npa20221005-hidden");
    // }
    
    
    //Remove everything else from the suggestion except the clicked option
    document.getElementById("npa20221005-suggestion").innerHTML = "";
    let option = document.createElement("div");
    option.classList.add("npa20221005-suggestion-option");
    option.innerHTML = "<button type = 'button' class='npa20221005-choosable-option'>"+ suggestionOption.dataset.breed +"</button>";
    option.addEventListener("click", function() {
       closeSuggestionBox();
    });
    document.getElementById("npa20221005-suggestion").appendChild(option);

    //Close the suggestion drop down as a suggestion has been already clicked
    document.getElementById("npa20221005-suggestion").classList.remove("npa20221005-block");
    document.getElementById("npa20221005-suggestion").classList.add("npa20221005-hidden");
}

function npaWeightRanges(dogbreed, tempObj, autoselect = false) {
    let tempSizeName = tempObj[0];
    let tempWeightRange = tempObj[1];
    let span1 = document.createElement("span");
    span1.classList.add("npa20221005-weight-range", "npa20221005-btn", "npa20221005-mb1", "npa20221005-mr1");
    span1.setAttribute("data-swatch", tempSizeName);
   // span1.innerHTML = tempSizeName + " (" + sizeids[tempSizeName][1]+ ")";
    span1.innerHTML = tempWeightRange;

    if(autoselect) {
      // console.log("Only one weight range");
      span1.classList.add("active");

      document.getElementById('weightProperties').value = span1.textContent;

      document.getElementById("npa20221005-final-leadingText").innerHTML = "Recommended sizes for your " + (dogbreed == "I don't know" ? 'dog' : dogbreed) + ':';

      let span2 = document.createElement("span");
      span2.classList.add("npa20221005-recommended-size", "npa20221005-btn", "npa20221005-mb1", "npa20221005-mr1");
      span2.innerHTML = tempSizeName + " (" + sizeids[tempSizeName][1]+ ")";

      span2.addEventListener("click", function() {  
          // let trgt = "."+(tempSizeName.toLowerCase())+"-"+sizeids[tempSizeName][1]+"-swatch label";
          let trgt = "."+(tempSizeName.toLowerCase())+"-"+sizeids[tempSizeName][1]+"-swatch";
          document.querySelector(trgt).click();

          // console.log('click on');
  
          // Show exchange info box if the weight and size are selected
          document.getElementById("npa20221005-exchange-info").classList.remove("npa20221005-hidden");
          document.getElementById("npa20221005-exchange-info").classList.add("npa20221005-block");
          
          if(is_iOS()) {
            let click_ev = document.createEvent("MouseEvent");
            click_ev.initEvent("click", false /* bubble */, true /* cancelable */);
            document.querySelector(trgt).dispatchEvent(click_ev);
          }

          Array.from(document.querySelectorAll(".npa20221005-recommended-size")).forEach( rc => {
              rc.classList.remove("active");
          });

          span2.classList.add("active");
      }, false);

      document.getElementById("npa20221005-final-results").innerHTML = "";
      document.getElementById("npa20221005-final-results").appendChild(span2);

      document.getElementById("npa20221005-weight-results").appendChild(span1);

      
      // If size is 1, make it active
      var recommendedSize = document.querySelectorAll(".npa20221005-recommended-size");

      if(span2 && recommendedSize.length == 1) {
        var clickEvent = new Event("click");
        span2.dispatchEvent(clickEvent);
      }

      
    } else {
      span1.addEventListener("click", function(){
   
        Array.from(document.querySelectorAll(".npa20221005-weight-range")).forEach( wr => {
            wr.classList.remove("active");
            span1.classList.add("active");

            document.getElementById("npa20221005-final-leadingText").innerHTML = "Recommended sizes for your " + (dogbreed == "I don't know" ? 'dog' : dogbreed) + ':';

            let span2 = document.createElement("span");
            span2.classList.add("npa20221005-recommended-size", "npa20221005-btn", "npa20221005-mb1", "npa20221005-mr1");
            span2.innerHTML = tempSizeName + " (" + sizeids[tempSizeName][1]+ ")";

          console.log("."+(tempSizeName.toLowerCase())+"-"+sizeids[tempSizeName][1]+"-swatch label",'tempSizeName', sizeids[tempSizeName][0]);

          // for the A/B Test Section
            if (abElement) {
              if (abAtcButton) {
                let cartLink = "/cart/"+sizeids[tempSizeName][0]+":1?storefront=true&discount=TRYTODAY";
                
                abAtcButton.setAttribute('href', cartLink);
                abAtcButton.textContent = "ADD TO CART";
                abAtcButton.classList.remove('disabled');
              }
            }

            span2.addEventListener("click", function() {
                // let trgt = "."+(tempSizeName.toLowerCase())+"-"+sizeids[tempSizeName][1]+"-swatch label";
                let trgt = "."+(tempSizeName.toLowerCase())+"-"+sizeids[tempSizeName][1]+"-swatch";
                document.querySelector(trgt).click();

                // console.log('click on');
        
                // Show exchange info box if the weight and size are selected
                document.getElementById("npa20221005-exchange-info").classList.remove("npa20221005-hidden");
                document.getElementById("npa20221005-exchange-info").classList.add("npa20221005-block");
              
                if(is_iOS()) {
                  let click_ev = document.createEvent("MouseEvent");
                  click_ev.initEvent("click", false /* bubble */, true /* cancelable */);
                  document.querySelector(trgt).dispatchEvent(click_ev);
                }

                Array.from(document.querySelectorAll(".npa20221005-recommended-size")).forEach( rc => {
                    rc.classList.remove("active");
                });

                span2.classList.add("active");
            }, false);

            document.getElementById("npa20221005-final-results").innerHTML = "";
            document.getElementById("npa20221005-final-results").appendChild(span2);
          

            // If size is 1, make it active
            var recommendedSize = document.querySelectorAll(".npa20221005-recommended-size");
            
            if (span2 && recommendedSize.length == 1) {
              span2.click();
            }
          
        });
    
    });

    document.getElementById("npa20221005-weight-results").appendChild(span1);

    }
}

function highlightOption(chosenByArrow) {
  Array.from(document.querySelectorAll(".npa20221005-suggestion-option")).forEach( opt => {
     opt.style.backgroundColor = "transparent";
  });

  document.querySelectorAll(".npa20221005-suggestion-option")[chosenByArrow].style.backgroundColor = "rgba(128,128,128,0.3)";
}

function bringSuggestionBox() {
  document.getElementById("npa20221005-suggestion").classList.remove("npa20221005-hidden");
  document.getElementById("npa20221005-suggestion").classList.add("npa20221005-block");
}

function addKeyDownEventForHighlight(eve) { 
    eve = eve || window.event;
    if(eve.repeat) { return; }
    decideWhatToHighlight(eve); 
}

function addKeyDownEventForEnter(evnt) {
  evnt = evnt || window.event;

  if(evnt.repeat) { return; }
    if(evnt.key == 'Enter') {
      evnt.stopImmediatePropagation();
      evnt.stopPropagation();
      document.querySelectorAll(".npa20221005-suggestion-option button")[chosenByArrow].click();
    } 
}

function decideWhatToHighlight(eve) {
    if(chosenByArrow >= 0) {
      if(eve.which == 40) {
         chosenByArrow++;
         if(chosenByArrow >= matchingResults-1) {
            chosenByArrow = matchingResults-1;
         }
      } else if(eve.which == 38) {
         chosenByArrow--;
         if(chosenByArrow < 0) {
           chosenByArrow = 0;
         }
      } 
      // console.log(chosenByArrow);
      highlightOption(chosenByArrow);
      downEventListening = true;
    }
}

function closeSuggestionBox() {
  document.getElementById("npa20221005-suggestion").classList.remove("npa20221005-block");
  document.getElementById("npa20221005-suggestion").classList.add("npa20221005-hidden");

  //window.addEventListener("keydown", addKeyDownEventForHighlight, false);
}

function is_iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

waitForNewTarget();